import { Controller } from "stimulus"
import axios from 'axios';
export default class extends Controller {

 static get targets() {
   return ['snippetLink'];
  }
 
  connect(){ 

  }

  slideTo(event){
   event.preventDefault(); 
   window.scroll(0, this.findPos(this.snippetLinkTarget));
 }

  findPos(obj) {
    var curtop = 0;
    if (obj.offsetParent) {
        do {
            curtop += obj.offsetTop;
        } while (obj = obj.offsetParent);
    return [curtop];
    }
}




}
